export default [{
  "type": "IOS",
  "name": "IOS",
  "settings": {},
  "children": []
}];